import api from "api/api";

const BASE_URL = 'studio/ventas/';

export const fetchAllVentas = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener las ventas:', error);
    throw error;
  }
};

export const fetchVentaById = async (id) => {
  try {
    const response = await api.get(BASE_URL + id + '/');
    return response.data;
  } catch (error) {
    console.error(`Error al obtener la venta con ID ${id}:`, error);
    throw error;
  }
};

export const createVenta = async (ventaData, sedeId = null) => {
  try {
    // Add sede_id to the payload if provided
    const payload = sedeId ? { ...ventaData, sede_id: sedeId } : ventaData;
    const response = await api.post(BASE_URL, payload);
    return response.data;
  } catch (error) {
    console.error('Error al crear una venta:', error);
    throw error;
  }
};

export const updateVenta = async (id, ventaData) => {
  try {
    const response = await api.patch(`${BASE_URL}${id}/`, ventaData);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar la venta con ID ${id}:`, error);
    throw error;
  }
};

export const deleteVenta = async (id) => {
  try {
    const response = await api.delete(BASE_URL + id + '/');
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar la venta con ID ${id}:`, error);
    throw error;
  }
};